import React from 'react'
import { getInsuranceMiniCardsFromTerms } from '../../domain/useCases/insurance/getInsuranceMiniCardsFromTerms'
import MiniCarousel from './MiniCarousel'
import { applyMinInsuranceThreshold } from '../../domain/useCases/insurance/applyMinInsuranceThreshold'

const INSURANCE_ANCHOR_THRESHOLD = 20

const MiniCarouselInsuranceRedirect = (props) => {
  const insuranceMiniCardList = getInsuranceMiniCardsFromTerms(
    props.terms,
    props.locationAcceptedInsurances,
    props.locationSlug,
    props.location
  )

  const insuranceMiniCardListTransformed = applyMinInsuranceThreshold(
    insuranceMiniCardList
  )

  const miniCarouselProps = {
    ...props,
    cards: insuranceMiniCardListTransformed,
    slug: props.locationSlug,
    customCardCountLimit: INSURANCE_ANCHOR_THRESHOLD,
    onCardClick: (card) => {
      location.pathname = card.slug
    },
    title: '',
    subTitle: ''
  }

  return <MiniCarousel {...miniCarouselProps} />
}

export default MiniCarouselInsuranceRedirect
